"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const uuid_1 = require("uuid");
/**
 * Set status of orderItem and the order to REFUNDED
 * @param event
 * @param prevState
 */
function default_1(event, prevState) {
    const order = prevState;
    order.orderItems = [
        {
            id: event.id || (0, uuid_1.v4)(),
            unitPrice: event.amount,
            quantity: 1,
            status: domain_1.OrderItemStatus.REFUNDED,
        },
    ];
    // In case of refund order amount, total should exclude these below fields.
    // deliveryFee, serviceCharge and tip.
    order.deliveryFee = 0;
    order.serviceCharge = 0;
    order.tip = 0;
    order.adjustments = [];
    order.refundType = domain_1.RefundType.BY_AMOUNT;
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
        roundingAmount: 0,
    };
}
exports.default = default_1;
//# sourceMappingURL=refundOrderAmount.js.map